import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'se-success-failure-renderer',
    templateUrl: './success-failure-renderer.component.html',
    styleUrls: ['./success-failure-renderer.component.scss'],
    standalone: false
})
export class SuccessFailureRendererComponent implements ICellRendererAngularComp {
    success: boolean = false;
    cancelled: boolean = false;
    failure: boolean = false;

    tooltipSuccess: string;
    tooltipFailure: string;
    tooltipCancelled: string;

    private data: any;

    constructor(private translate: TranslateService) {}

    refresh(params): boolean {
        this.updateParams(params);

        return true;
    }

    agInit(params): void {
        this.updateParams(params);
    }

    private updateParams(params) {
        this.success = (params.data[params.state] == 0);
        this.failure = (params.data[params.state] == 1);
        this.cancelled = (params.data[params.state] == -1);

        if (params.tooltipSuccess)
            this.tooltipSuccess = this.translate.instant(params.tooltipSuccess);

        if (params.tooltipFailure)
            this.tooltipFailure = this.translate.instant(params.tooltipFailure);

        if (params.tooltipCancelled)
            this.tooltipCancelled = this.translate.instant(params.tooltipCancelled);
    }
}
